<div>
  <tt-file-drag-drop
    class="reference-popover_add-file"
    [allowedTypes]="allowedTypes"
    [file]="attachment()?.file"
    [info]="'DragAndDropAssetsFiles'"
    (fileChanged)="handleFileChanged($event)" />
  <tt-form-field>
    <label ttLabel>{{ 'AttachmentTitle' | transloco }}:</label>
    <input ttInput [ngModel]="attachment()?.name" (ngModelChange)="handleFileNameChanged($event)" />
  </tt-form-field>
</div>
